import { baseGlobals } from '@root/typescript/baseGlobals'

import ajax from '@common/ajax/simple/ajax'

import UserAgent from '@common/UserAgent/UserAgent'

import type getNormalizedError from '@common/onError/client/getNormalizedError'

import type { IRequest, IRuntimeErrorData } from '@statService/backend/definitions'

import { EStatRoute } from '@statService/backend/definitions'

type TNormalizedError = ReturnType<typeof getNormalizedError>

export default class StatService {
  /**
   * Kliens oldali statisztika küldés a service-nek.
   * @param request - A szervernek küldendő adat.
   */
  public static send (request: IRequest): void {
    if (baseGlobals.isProd) {
      ajax({
        url: `https://statservice.balazs-diak.hu${ EStatRoute.Insert }`,
        onSuccess: () => { /* noop */ },
        onError: () => { /* noop */ },
        data: request
      })
    }
  }

  /**
   * Runtime error adatok küldése a szervernek.
   * @param project         - A project neve, ahonnan jön az adat.
   * @param normalizedError - Az adat.
   */
  public static sendRuntimeError (project: string, normalizedError: TNormalizedError): void {
    const userAgent = UserAgent.getNavigatorUserAgent()

    // Egy egyszerű botszűrés.
    if ((/bot|crawl|duckduckgo|slurp|spider|yandex/i).test(userAgent)) {
      return
    }

    const { columnNumber, lineNumber, message, stack } = normalizedError

    const data: IRuntimeErrorData = {
      // Melyik project / app.
      project,

      // A normalizált error részei.
      stack: stack.join('\n'),
      columnNumber,
      lineNumber,
      message,

      // Browser adatok.
      resolution: `${ window.screen.width }x${ window.screen.height }`,
      userAgent
    }

    StatService.send({
      project: 'runtimeErrors',
      data
    })
  }
}
